'use client';
import { getStrapiMedia } from '@/lib/media';
import Image from 'next/image';
import Link from 'next/link';
import React, { useState } from 'react';
import { NoDataFound } from './NoData';
import { NextBtnIcon, PrevBtnIcon } from './SvgFiles';

const RelatedArticleWithSlider = ({ relatedArticleList }: any) => {
  const [startIndex, setStartIndex] = useState(0);

  const goToNextCards = () => {
    if (startIndex + 3 < relatedArticleList.length) {
      setStartIndex(startIndex + 3);
    }
  };

  const goToPreviousCards = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 3);
    }
  };
  return (
    <>
      {Boolean(relatedArticleList?.length) && (
        <section className='mt-[0px]  lg:mt-[200px]'>
          <section className='flex items-center justify-between pr-[22px] max-lg:overflow-auto '>
            <span className='text-left text-[22px] font-semibold dark:text-white max-lg:mr-auto'>
              Related Posts
            </span>
            <section className='flex gap-[10px] max-lg:hidden'>
              <button
                id='prevBtn'
                className={`h-[30px] w-[30px]`}
                onClick={goToPreviousCards}
              >
                <span className='sr-only'>Prev button</span>
                <PrevBtnIcon
                  className=''
                  color={`${
                    startIndex === 0
                      ? 'fill-[#898e9b]'
                      : 'dark:fill-[#00b4b9] fill-[#1c2534]'
                  } `}
                />
              </button>
              <button
                id='nextBtn'
                className={`h-[30px] w-[30px]`}
                onClick={goToNextCards}
              >
                <span className='sr-only'>Next button</span>
                <NextBtnIcon
                  className=''
                  color={`${
                    startIndex === relatedArticleList.length - 3
                      ? 'fill-[#898e9b]'
                      : 'dark:fill-[#00b4b9] fill-[#1c2534]'
                  } `}
                />
              </button>
            </section>
          </section>
          <section className='ml-[-22px] flex  w-auto gap-[15px] overflow-x-scroll p-[22px] lg:grid lg:grid-cols-3 lg:gap-[35px] lg:overflow-auto'>
            {!!relatedArticleList?.length ? (
              relatedArticleList
                ?.slice(startIndex, startIndex + 3)
                ?.map((item: any) => (
                  <PostCard key={item.id} card={item.attributes} />
                ))
            ) : (
              <NoDataFound />
            )}
          </section>
        </section>
      )}
    </>
  );
};

export default RelatedArticleWithSlider;

const PostCard = ({ card }: any) => {
  return (
    <section className='max-sm:w-[250px] max-sm:flex-shrink-0'>
      <Link href={`/${card?.slug}`} className=''>
        <section className='relative'>
          <Image
            src={getStrapiMedia(card?.card_image)}
            alt='feature Image'
            width={400}
            height={300}
            className=' mb-[12px] h-[160px] w-[250px] rounded-[10px] object-cover'
          ></Image>
          {/* catagory */}
          <span className='absolute right-[10px] top-[10px] rounded-[5px] bg-white p-[5px_10px] text-[12px] text-[#1c2534] drop-shadow-lg'>
            {card?.readingTime ? card?.readingTime : 'no data'}
          </span>
        </section>
        <h2 className='mt-[18px] line-clamp-2 text-left text-[16px] font-semibold leading-[1.38] dark:text-white'>
          {card?.title ? card?.title : 'no data'}
        </h2>
      </Link>
    </section>
  );
};
